module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_blue_07-f125b4680e5ec5069f690f714e8c51bd.svg";